const translations = {
    discountLabel: 'Discount',
    invoiceTotalLabel: 'Invoice Total',
    salesTaxLabel: 'Sales Tax',
    shippingCostLabel: 'Shipping',
    subtotalLabel: 'Subtotal'
};

export default translations;
